
export interface EnvironmentFilterData {
  id: string;
  prompt_name: string;
  priority: number;
  tags: string[];
}

export const ENVIRONMENT_FILTERS: EnvironmentFilterData[] = [
  {
    id: "env-indoor",
    prompt_name: "Indoor",
    priority: 100,
    tags: ["interior", "enclosed"]
  },
  {
    id: "env-outdoor",
    prompt_name: "Outdoor",
    priority: 90,
    tags: ["exterior", "open-air"]
  },
  {
    id: "env-forest",
    prompt_name: "Forest",
    priority: 80,
    tags: ["trees", "nature"]
  },
  {
    id: "env-beach",
    prompt_name: "Beach",
    priority: 70,
    tags: ["ocean", "sand"]
  },
  {
    id: "env-mountain",
    prompt_name: "Mountain",
    priority: 60,
    tags: ["peaks", "elevation"]
  },
  {
    id: "env-city",
    prompt_name: "City",
    priority: 50,
    tags: ["urban", "buildings"]
  },
  {
    id: "env-desert",
    prompt_name: "Desert",
    priority: 40,
    tags: ["arid", "sand"]
  },
  {
    id: "env-space",
    prompt_name: "Space",
    priority: 30,
    tags: ["cosmic", "stars"]
  },
  {
    id: "env-underwater",
    prompt_name: "Underwater",
    priority: 20,
    tags: ["aquatic", "submerged"]
  },
  {
    id: "env-fantasy",
    prompt_name: "Fantasy Realm",
    priority: 10,
    tags: ["magical", "otherworldly"]
  }
];
